import * as ng from 'angular';
import refs from "./vendor-modules";
import AppComponent from "./app/app-component";
import AdminModule from './app/components/admin';
import DashboardModule from './app/components/dashboard';
import ProfileModule from './app/components/profile';
import PublicModule from './app/components/public';
import SecurityModule from './app/components/security';
import DataModule from './app/data';
import ServicesModule from './app/services';
import UserControlsModule from './app/user-controls';
import CoreModule from './app/core';
import themeConfig from "./app/theme-config";
import blockUIConfig from "./app/blockui-config";

ng.module(AppComponent.name, [
    refs.ngAnimate,
    refs.ngRouter,
    refs.ngMessages,
    refs.ngMaterial,
    refs.ngWizard,
    refs.ngBlockUI,
    refs.ngPrint,
    refs.ngMoment,
    refs.ngQuill,
    CoreModule.name,
    DataModule.name,
    ServicesModule.name,
    UserControlsModule.name,
    SecurityModule.name,
    AdminModule.name,
    DashboardModule.name,
    ProfileModule.name,
    PublicModule.name,
])
    .value('$routerRootComponent', AppComponent.name) 
    .config(blockUIConfig)
    .config(themeConfig)
    .component(AppComponent.name, AppComponent.registration)

    .config(($locationProvider: ng.ILocationProvider) => {
        $locationProvider.hashPrefix("");
    })
    .run(["gettextCatalog", (gettextCatalog: ng.gettext.gettextCatalog) => {

        if (location.protocol === 'http:') {
            window.location.href = location.href.replace('http', 'https');
        }

        (gettextCatalog as any).currentLanguage = 'en';
        gettextCatalog.debug = true;      
    }]);





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./index.ts